import * as _ from 'lodash';
import { ZoningCode, ZoningCodeVersion } from '.';

export class ZoningCodeVersionButtons {
    zoningCode: ZoningCode;
    zoningCodeVersion: ZoningCodeVersion;

    get showActionsForSelectedZCVersion(): boolean {
        return this.zoningCode && this.zoningCode.PropertyRecordsCount > 0;
    }

    get checkActionsAndActualVersion(): boolean {
        if (!this.zoningCodeVersion) {
            return;
        }
        return (
            this.showActionsForSelectedZCVersion &&
            this.zoningCodeVersion.ActualVersion === this.zoningCode.ActualVersion
        );
    }

    get isDeleting(): boolean {
        return _.get(this.zoningCode, 'isDeleting') || _.get(this.zoningCodeVersion, 'isDeleting');
    }

    get isOrphan(): boolean {
        return _.get(this.zoningCode, 'isOrphan');
    }
}
